export default "__VITE_ASSET__6bf973d9__"